module.exports = __webpack_public_path__ + "img/wide.69dcca36.jpg";